import { useState, useEffect } from "react";
import { PopupModal } from "../../../../components/PopupModal";
import { VideoForm } from "./VideoForm";
import { Button } from "../../../../components/Button";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/x.svg";
import { api } from "../../../../helpers/api";
import { createAssetsMux } from "../../../../helpers/muxVideoMasking";
import { ShowToast } from "../../../../components/toast";


export function SingleVideoPopup({
  open,
  onClose,
  onUpdate,
  data,
  videoDetails,
}: any) {
  const [saving, setSaving] = useState(false);
  const [videoData, setVideoData] = useState<any>({});

  const onChange = (data: any) => {
    if (data) {
      setVideoData(data);
    }
  };

  const isLandscapeUpdate = async (isLandscape) => {
    if (data?.is_landscape !== 1 && isLandscape) {
      await api.updatePublisherVideo(data.video_id, {
        video_id: data?.video_id,
        is_landscape: 1,
      });
    }
  };

  const onSubmit = async () => {
    try {
      setSaving(true);
      let res;
      if (videoDetails?.sub_video_id) {
        res = await api.updateSubVideo(videoDetails?.sub_video_id, {
          ...videoData,
        });
      } else {
        const hlsVideoUrl = await createAssetsMux(videoData?.url);

        if (data?.is_landscape) {
          await isLandscapeUpdate(data?.is_landscape);
        }

        res = await api.saveSubVideo({
          ...videoData,
          url_hls: hlsVideoUrl,
          video_id: data?.video_id,
          duration: Math.round(videoData?.duration * 1000),
        });
      }
      setSaving(false);
      if ([200, 201].includes(res?.status)) {
        onUpdate();
        onClose();
        ShowToast({
          message: "Lesson added successfully",
          type: "success",
        });
      }
    } catch (error) {
      setSaving(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (videoDetails) {
      setVideoData(videoDetails);
    }
  }, [videoDetails]);

  console.log(data, videoDetails);
  return (
		<PopupModal open={open} onClose={onClose}>
			<div className="flex items-center justify-between mb-4">
				<h2 className="text-2xl font-semibold">Add Lesson</h2>
				<button onClick={onClose}>
					<CloseIcon />
				</button>
			</div>
			<VideoForm onChange={onChange} data={videoData} />
			<div className="flex justify-end mt-5">
				<Button
					variant="primary"
					onClick={onSubmit}
					loading={saving}
					disabled={!videoData?.url || !videoData?.title}
				>
					{videoDetails?.sub_video_id ? "Update" : "Add"}
				</Button>
			</div>
		</PopupModal>
	);
}
